import { render, staticRenderFns } from "./ApplySendAs.vue?vue&type=template&id=eb5836cc"
import script from "./ApplySendAs.vue?vue&type=script&lang=js"
export * from "./ApplySendAs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports